<template>
  <ais-range-input :attribute="attribute">
    <template #default="{ currentRefinement, range, refine }">
      {{ notifyCount ? notifyCount(currentRefinement.max || currentRefinement.min ? 1 : 0) : '' }}
      <RangeSlider
        :input="toValue(currentRefinement, range)"
        :min="range.min"
        :max="range.max"
        :step="1"
        :pow="2.5"
        :prepend="currencySymbol"
        tooltip="bottom"
        @drag-end="value => onPriceInput(value[0], value[1], refine)"
      />
    </template>
  </ais-range-input>
</template>

<script>
import { AisRangeInput } from 'vue-instantsearch';
import RangeSlider from '../RangeSlider.vue';

export default {
  components: { AisRangeInput, RangeSlider },
  props: {
    attribute: {
      type: String,
      default: '',
    },
    currencySymbol: {
      type: String,
      default: '€',
    },
    notifyCount: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      range: null,
    };
  },
  methods: {
    /**
     * @param {{ min: Number; max: Number; }} value
     * @param {{ min: Number; max: Number; }} range
     */
    toValue(value, range) {
      this.range = range;
      return [
        value.min !== null && value.min !== undefined ? value.min : range.min,
        value.max !== null && value.max !== undefined ? value.max : range.max,
      ];
    },

    /**
     * @param {Number} min
     * @param {Number} max
     * @param {(arg0: { min: Number; max: Number; }) => void} refine
     */
    onPriceInput(min, max, refine) {
      refine({ min, max });
      this.$emit(
        'filter-update',
        `${min}-${max}`,
        min !== this.range.min || max !== this.range.max ? 1 : 0
      );
    },
  },
};
</script>
